import { Button, type ButtonVariant } from "@mantine/core";
import clsx from "clsx";
import { type MouseEvent, useState } from "react";
import { StripeCheckoutModal } from "./stripe-checkout-modal";

type BuyButtonProps = {
	children: React.ReactNode;
	className?: string;
	variant?: ButtonVariant | string;
	disabled?: boolean;
	discountCode?: string;
	zIndex?: number;
	onCheckoutStart?: () => void;
	onCheckoutComplete?: () => void;
} & (
	| {
			priceId: string | null;
			onClick?: never;
	  }
	| {
			priceId?: never;
			onClick: (e: MouseEvent<HTMLButtonElement>) => void;
	  }
);

export function BuyButton(props: BuyButtonProps) {
	const [checkoutModalOpened, setCheckoutModalOpened] = useState(false);

	const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();

		// If custom onClick handler provided, use it
		if (props.onClick) {
			props.onClick(e);
			return;
		}

		// Otherwise, open Stripe checkout
		if (!props.priceId || props.disabled) {
			return;
		}

		props.onCheckoutStart?.();
		setCheckoutModalOpened(true);
	};

	const handleCheckoutClose = () => {
		setCheckoutModalOpened(false);
		props.onCheckoutComplete?.();
	};

	const isDisabled = props.disabled || (!props.priceId && !props.onClick);

	return (
		<>
			<Button
				variant={props.variant}
				disabled={isDisabled}
				className={clsx("py-2 h-10 w-full", props.className)}
				onClick={handleClick}
			>
				{props.children}
			</Button>

			{props.priceId && checkoutModalOpened && (
				<StripeCheckoutModal
					key={props.priceId}
					opened={checkoutModalOpened}
					onClose={handleCheckoutClose}
					priceId={props.priceId}
					discountCode={props.discountCode}
					zIndex={props.zIndex}
				/>
			)}
		</>
	);
}
